(function () {
  function initVariantDescription() {
    const wrapper = document.getElementById('variant-description-wrapper');
    if (!wrapper || !window.__variantMeta) return;

    let lastVariantId = null;

    function getVariantIdFromForm() {
      const form =
        wrapper.closest('section')?.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]');

      if (!form) return null;

      const idInput = form.querySelector('input[name="id"], select[name="id"]');
      return idInput && idInput.value ? String(idInput.value) : null;
    }

    function getVariantIdFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const id = params.get('variant');
      return id ? String(id) : null;
    }

    function getCurrentVariantId() {
      return getVariantIdFromForm() || getVariantIdFromUrl();
    }

    function updateDescription(variantId) {
      if (!variantId) return;

      variantId = String(variantId);

      if (variantId === lastVariantId) return;
      lastVariantId = variantId;

      const html = window.__variantMeta[variantId];

      if (html) {
        wrapper.innerHTML = html;
      } else {
        wrapper.innerHTML = '';
      }
    }

    function checkAndUpdate() {
      const variantId = getCurrentVariantId();
      updateDescription(variantId);
    }

    // أول تحميل
    checkAndUpdate();

    // عند تغيير أي خيار
    document.addEventListener(
      'change',
      function (event) {
        if (
          event.target.matches('select') ||
          event.target.matches('input[type="radio"]') ||
          event.target.matches('input[name="id"]') ||
          event.target.closest('variant-selects') ||
          event.target.closest('variant-radios') ||
          event.target.closest('.product-form__input')
        ) {
          setTimeout(checkAndUpdate, 50);
          setTimeout(checkAndUpdate, 150);
          setTimeout(checkAndUpdate, 300);
          setTimeout(checkAndUpdate, 600);
        }
      },
      true
    );

    // بعض الثيمات تغيّر الخيار بالضغط وليس change
    document.addEventListener(
      'click',
      function (event) {
        if (
          event.target.closest('variant-selects') ||
          event.target.closest('variant-radios') ||
          event.target.closest('.product-form__input') ||
          event.target.closest('[data-option-value-id]')
        ) {
          setTimeout(checkAndUpdate, 50);
          setTimeout(checkAndUpdate, 150);
          setTimeout(checkAndUpdate, 300);
          setTimeout(checkAndUpdate, 600);
        }
      },
      true
    );

    // إذا الثيم يطلق events خاصة
    document.addEventListener('variant:change', function (event) {
      if (event.detail?.variant?.id) {
        updateDescription(event.detail.variant.id);
      } else {
        setTimeout(checkAndUpdate, 100);
      }
    });

    document.addEventListener('product:variant-change', function (event) {
      if (event.detail?.variant?.id) {
        updateDescription(event.detail.variant.id);
      } else {
        setTimeout(checkAndUpdate, 100);
      }
    });

    // مراقبة مستمرة بسيطة، لأنها تحل مشكلة الثيمات التي تغير variant بدون event
    setInterval(checkAndUpdate, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantDescription);
  } else {
    initVariantDescription();
  }

  document.addEventListener('shopify:section:load', initVariantDescription);
})();